import request from "../utils/request";

/** 稽核紀錄（含變更前後值）；支援 skip / take / keyword / account 等查詢條件 */
export function GET_AuditList(token, payload) {
  return request.get("/Audit/List", payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
}

/** 稽核紀錄的篩選選項（全庫出現過的操作者與動作），給下拉選單用 */
export function GET_AuditFilters(token, payload) {
  return request.get("/Audit/Filters", payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
}
